import { useEffect, useState, useMemo } from 'react';
import { useLocation, Link } from 'react-router-dom';
import './PageStyle.css';

function SuccessPage() {
  const location = useLocation();
  const [language, setLanguage] = useState('AR');
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const paramsObject = useMemo(() => {
    const obj = {};
    for (const [key, value] of params.entries()) {
      obj[key] = value;
    }
    return obj;
  }, [params]);
  useEffect(() => {
    const rawLang = paramsObject?.lang?.toUpperCase();
    const upperLang = rawLang === 'EN' || rawLang === 'AR' ? rawLang : language;
    setLanguage(upperLang);

    const menuToggle = document.getElementById('menuToggle');
    const sidebar = document.getElementById('sidebar');
    const closeSidebar = document.getElementById('closeSidebar');

    if (menuToggle && sidebar && closeSidebar) {
      const openSidebar = () => sidebar.classList.add('open');
      const closeSide = () => sidebar.classList.remove('open');

      menuToggle.addEventListener('click', openSidebar);
      closeSidebar.addEventListener('click', closeSide);

      return () => {
        menuToggle.removeEventListener('click', openSidebar);
        closeSidebar.removeEventListener('click', closeSide);
      };
    }
  }, []);

  const handleLanguage = (value) => {
    setLanguage(value);
  };

  return (
    <div className="App">
      <div className='top'>
        <div className='bar'>
          <div className="bar-left">
            <img className="logo" src="/logo.png" alt="CoreFlex"></img>
          </div>
          <div className="bar-right">
            <div className='language'>
              <button className={language === 'EN' ? 'active' : ''} onClick={() => handleLanguage('EN')}>EN</button>
              <button className={language === 'AR' ? 'active' : ''} onClick={() => handleLanguage('AR')}>AR</button>
            </div>
            <div className="menu-label" id="menuToggle">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
      <div className="sidebar" id="sidebar">
        <div className="close-btn" id="closeSidebar">&times;</div>
        <ul className="menu-items">
          <li dir={language === 'EN' ? 'ltr' : 'rtl'}><Link to={`/terms?lang=${language}`}>{language === 'EN' ? 'Terms & Conditions' : 'الأحكام والشروط'}</Link></li>
          <li dir={language === 'EN' ? 'ltr' : 'rtl'}><Link to={`/privacy?lang=${language}`}>{language === 'EN' ? 'Privacy Policy' : 'سياسة الخصوصية'}</Link></li>
          <li dir={language === 'EN' ? 'ltr' : 'rtl'} onClick={() => window.location.href = 'mailto:support@coreflex.fun'}>{language === 'EN' ? 'Contact us' : 'معلومات الاتصال'}</li>
        </ul>
      </div>
      <div className='middle'>
        <div className='title' dir={language === 'EN' ? 'ltr' : 'rtl'}>{language === 'EN' ? 'Enjoy using the mobile app for all types of fitness workouts' : 'استمتع باستخدام تطبيق الهاتف لجميع أنواع تمارين اللياقة البدنية'}</div>
        <div className='input-content'>
          <br></br> <br></br> <br></br>
          <div className='title' dir={language === 'EN' ? 'ltr' : 'rtl'}><p>{language === 'EN' ? 'Congratulations! You have successfully subscribed' : 'مبروك! لقد اشتركت بنجاح'}</p></div>
          <div className='button success-page'>
            <a id='access-app-btn' className='active' href='https://link-to.app/iRdfLxFVEq'>{language === 'EN' ? 'ACCESS APP' : 'الدخول إلى التطبيق'}</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SuccessPage;
